import React from 'react'
import styles from './modelsBar.module.css'
import RealSlider from './RealSlider'
import { useGetModelsQuery } from '../../features/products/productsApiSlice'

const getItemsCount = () => {
    if (window.innerWidth >= 840) return 6
    if (window.innerWidth > 640) return 4
    if (window.innerWidth > 440) return 3
    return 2
}

const ModelsBar = () => {
    const { data: models, isSuccess } = useGetModelsQuery()

    if (!isSuccess || !models?.length) return null

    return (
        <div className="app_container">
            <div className={styles.models_bar}>
                <RealSlider items={models} itemsPerPage={getItemsCount()} />
            </div>
        </div>
    )
}

export default ModelsBar
